'use client';

import { getCrmPointsRules } from '@/api/public';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { IS_DE } from '@/utils/constants';
import { env } from '@/utils/env';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { PointFilled } from '@zeelool/icon';
import { useTranslations } from '@/i18n/use-translations';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function YouPoints({
  SDRewardsPageBtnClick,
}: {
  SDRewardsPageBtnClick: (btnName: string) => void;
}) {
  const userInfo = useStore((state) => state.userInfo);
  const [crmPointRule, setCrmPointRule] = useState<any>({});
  const router = useRouter();
  const t = useTranslations('zeeloolRewards');
  const currency = useStore((state) => state.currency);

  const getCrmPointRuleAction = async () => {
    const { code, data } = await getCrmPointsRules();
    if (code === 200) {
      setCrmPointRule(data);
    }
  };

  useEffect(() => {
    getCrmPointRuleAction();
  }, []);

  function handleRedeem() {
    SDRewardsPageBtnClick('Rewards Store');
    router.push('/account/points-mall');
  }

  function handleCart() {
    SDRewardsPageBtnClick('Cart');
    router.push('/cart');
  }

  function handleShopNow(groupID: string) {
    SDRewardsPageBtnClick('Shop Now');
    // ZELL-64382 记录从Zeelool Rewards进入商品列表
    sessionStorage.setItem('zl_goodsListEnterPageScene', 'Zeelool Rewards');
    router.push(`/goods-list/${groupID}`);
  }

  return (
    <>
      <WebOnly>
        <div className="w-[58%] h-[210px] rounded-[12px] bg-[#f4f4f4]">
          <div className="flex flex-col items-center h-full">
            <div className="flex items-center pt-48">
              <PointFilled className="text-48" />
              <span className="text-32 font-bb ml-10">
                {userInfo.point || 0}{' '}
                {userInfo.point > 0 ? t('youPoints.points') : t('youPoints.point')}
              </span>
            </div>
            <p className="mt-24 font-br text-14 leading-[14px]">
              {t('youPoints.getDiscountsWhenPurchase')} ({crmPointRule?.deduct?.ratio}{' '}
              {t('youPoints.points')} ={' '}
              {formatPriceNumberWithSymbol(crmPointRule?.deduct?.dollar, currency, false, 0)})
            </p>
            <p className="mt-12 font-br text-14 leading-[14px]">
              {t('youPoints.redeemInThe')}{' '}
              <span className="underline cursor-pointer" onClick={() => handleRedeem()}>
                {t('youPoints.rewardsStore')}
              </span>{' '}
              ({crmPointRule?.deduct?.integral_product_ratio} {t('youPoints.points')} ={' '}
              {formatPriceNumberWithSymbol(crmPointRule?.deduct?.dollar, currency, false, 0)})
            </p>
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="w-full  rounded-[13px] bg-[#f4f4f4] py-16">
          <div className="flex flex-col items-center h-full">
            <div className="flex items-center">
              <PointFilled className="text-32" />{' '}
              <span className="text-24 font-bb ml-8">
                {userInfo.point || 0}{' '}
                {userInfo.point > 0 ? t('youPoints.points') : t('youPoints.point')}
              </span>
            </div>
            <p className="mt-12 font-br text-[11px] leading-[13px]">
              {t('youPoints.getDiscountsWhenPurchase')} ({crmPointRule?.deduct?.ratio}{' '}
              {t('youPoints.points')} ={' '}
              {formatPriceNumberWithSymbol(crmPointRule?.deduct?.dollar, currency, false, 0)})
            </p>
            <p className="mt-6 font-br text-[11px] leading-[13px]">
              {t('youPoints.redeemInThe')}{' '}
              <span className="underline cursor-pointer" onClick={() => handleRedeem()}>
                {t('youPoints.rewardsStore')}
              </span>{' '}
              ({crmPointRule?.deduct?.integral_product_ratio} {t('youPoints.points')} ={' '}
              {formatPriceNumberWithSymbol(crmPointRule?.deduct?.dollar, currency, false, 0)})
            </p>
          </div>
        </div>
        {['us', 'ca'].includes(env.NEXT_PUBLIC_SITE_NAME) && (
          <div className="mt-12 text-12 font-br">
            {t('youPoints.viewYour')}{' '}
            <span className="underline cursor-pointer" onClick={() => handleCart()}>
              {t('youPoints.cart')}
            </span>{' '}
            {t('youPoints.or')}{' '}
            <span
              className="underline cursor-pointer"
              onClick={() => handleShopNow(env.NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_LINK)}
            >
              {t('youPoints.shopNow')}
            </span>
          </div>
        )}
        {IS_DE && (
          <div className="mt-12 text-12 font-br">
            <span className="underline cursor-pointer" onClick={() => handleCart()}>
              {t('youPoints.cart')}
            </span>{' '}
            {t('youPoints.viewYour')}{' '}
            <span
              className="underline cursor-pointer"
              onClick={() => handleShopNow(env.NEXT_PUBLIC_ZEELOOL_REWARDS_SHOP_NOW_LINK)}
            >
              {t('youPoints.shopNow')}
            </span>
          </div>
        )}
      </WapOnly>
    </>
  );
}
